module.exports = __webpack_public_path__ + "static/img/22s.3322cb4.png";


//////////////////
// WEBPACK FOOTER
// ./img/yj/22s.png
// module id = 7srL
// module chunks = 1